import { globalProps } from "neetocommons/initializers";
import { dayjs } from "neetocommons/utils";
import { Select, DatePicker } from "neetoui";
import PropTypes from "prop-types";
import { prop } from "ramda";

import { defaultTimePeriodOptions } from "./utils";

const DateRangeFilter = ({
  timePeriodOptions,
  timePeriod,
  setTimePeriod,
  datePickerProps,
}) => {
  const isCustom =
    timePeriod?.value === "custom" || timePeriod?.value?.rangeType === "custom";

  const startDate = timePeriod?.value?.startDate;
  const endDate = timePeriod?.value?.endDate;
  const requiredDateFormat = globalProps?.user?.dateFormat;

  const options = timePeriodOptions || defaultTimePeriodOptions();

  return (
    <div
      className="neeto-molecules-date-range-filter flex flex-wrap gap-3"
      data-testid="date-range-filter"
    >
      <div className="neeto-molecules-date-range-filter__select w-40">
        <Select
          {...{ options }}
          required
          getOptionValue={prop("label")}
          strategy="fixed"
          value={timePeriod || options[0]}
          onChange={option => setTimePeriod(option)}
        />
      </div>
      {isCustom && (
        <div
          className="neeto-molecules-date-range-filter__custom-duration-picker max-w-sm flex-grow"
          data-testid="date-range-filter-custom-duration-picker"
        >
          <DatePicker
            autoFocus
            className="w-full"
            dateFormat={requiredDateFormat}
            picker="date"
            type="range"
            value={[
              startDate ? dayjs(startDate) : null,
              endDate ? dayjs(endDate) : null,
            ]}
            onChange={([startDate, endDate]) => {
              setTimePeriod({
                label: timePeriod?.label,
                value: { startDate, endDate, rangeType: "custom" },
              });
            }}
            {...datePickerProps}
          />
        </div>
      )}
    </div>
  );
};

DateRangeFilter.propTypes = {
  /**
   * An array of objects that can be passed to the component which can be used to override default filter options.
   */
  timePeriodOptions: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.object })
  ),
  /**
   * The state corresponding to the currently selected date range filter.
   */
  timePeriod: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.object,
  }),
  /**
   * The setter method for `timePeriod` state.
   */
  setTimePeriod: PropTypes.func,
  /**
   * These props will be passed to the date range picker for custom date range selection.
   */
  datePickerProps: PropTypes.object,
};

export default DateRangeFilter;
